import axios from '@dap/shared-utils/http.js';

export default {
    // getTableList (params = {}) {
    //     return axios.get('/dapper/api/aud/aud_crowds', { params });
    // },

    getCheckName (params = {}) {
        return axios.get('/dapper/api/aud/check_name', { params });
    },

    getTableList (params = {}) {
        return axios.get('/dapper/api/aud/crowds', { params });
    },

    getSystemRecommendList (params = {}) {
        return axios.get('/dapper/api/aud/ks_audiences/system_recommend', { params });
    },

    getSpreader (params = {}) {
        return axios.get('/dapper/api/aud/spreader', { params });
    },
    getOrientationList (params = {}) {
        return axios.get('/dapper/api/aud/orientation', { params });
    },

    postPresent (params = {}) {
        if (!params.audience_id) {
            return axios.post('/dapper/api/aud/audiences', params);
        }

        return axios.put('/dapper/api/aud/audiences', params);
    },

    getEditData (params = {}) {
        return axios.get('/dapper/api/aud/copy', { params });
    },

    getAPPSearch (params = {}) {
        return axios.get('/dapper/api/aud/apps', { params });
    },

    getFormName (params = {}) {
        return axios.post('/dapper/api/aud/ver_name', params);
    },

    getGdtOrientation (params = {}) {
        return axios.get('/dapper/api/aud/gdt_orientation', { params });
    },

    getGdtInterest (params = {}) {
        return axios.get('/dapper/api/aud/gdt_interest', { params });
    },

    getGdtBehavior (params = {}) {
        return axios.get('/dapper/api/aud/gdt_behavior', { params });
    },

    updateGdtAudiences (params = {}) {
        if (params.audience_id) {
            return axios.put('/dapper/api/aud/gdt_audiences', params, {
                headers: { 'Content-Type': 'application/json' },
            });
        }
        return axios.post('/dapper/api/aud/gdt_audiences', params, {
            headers: { 'Content-Type': 'application/json' },
        });
    },

    getGdtAudienceLog (params = {}) {
        return axios.get('/dapper/api/aud/gdt_audiences/log', { params });
    },

    getGdtProgress (params = {}) {
        return axios.get('/dapper/api/aud/gdt_audiences/log/push_status', {
            params,
        });
    },

    getRelationAds (params = {}) {
        return axios.get('/dapper/api/aud/gdt_audiences/relation', { params });
    },

    getGdtAudiencesUpdateData (params = {}) {
        return axios.get('/dapper/api/aud/gdt_copy', { params });
    },

    getFlowPackageList (params = {}) {
        return axios.get('/dapper/api/aud/flow_package', { params });
    },

    getToutiaoCategory (params = {}) {
        return axios.get('/dapper/api/aud/action_interest/category', {
            params,
        });
    },

    getToutiaoKeywords (params = {}) {
        return axios.get('/dapper/api/aud/action_interest/keyword', { params });
    },

    getRecommendData (params = {}) {
        return axios.get('/dapper/api/aud/action_interest/recon', { params });
    },

    getBatchData (params = {}) {
        return axios.get('/dapper/api/aud/action_interest/batch', { params });
    },

    getCategorySearchData (params = {}) {
        return axios.get('/dapper/api/aud/action_interest/category/keyword', {
            params,
        });
    },

    getKeywordsUpdate (params = {}) {
        return axios.get('/dapper/api/aud/action_interest/int_update', {
            params,
        });
    },

    getGdtBatch (params = {}) {
        return axios.post('/dapper/api/aud/gdt_action_interest/batch', params);
    },

    getGdtRecommendData (params = {}) {
        return axios.get('/dapper/api/aud/gdt_action_interest/recommend', {
            params,
        });
    },

    getGdtInterestData (params = {}) {
        return axios.get('/dapper/api/aud/gdt_interest/cover_num', { params });
    },

    getAwemeFanListData (params = {}) {
        return axios.get('/dapper/api/aud/aweme_fan/list', { params });
    },

    getAwemeFanSearchData (params = {}) {
        return axios.get('/dapper/api/aud/aweme_fan/search', { params });
    },

    getGdtAudienceEstimate (params = {}) {
        return axios.post('/dapper/api/aud/gdt/audience_estimate', params, {
            headers: { 'Content-Type': 'application/json' },
        });
    },

    getGdtSwitchFormat (params = {}) {
        return axios.post('/dapper/api/aud/gdt/switch_format', params, {
            headers: { 'Content-Type': 'application/json' },
        });
    },
};
